export default __webpack_public_path__ + "static/media/groupings.a7ac39c8.svg";